import activityLog from './activityLog.json'
import auth from './auth.json'
import cabinetsPage from './cabinetsPage.json'
import configIssues from './configIssues.json'
import configurationEditorPage from './configurationEditorPage.json'
import configurationModel from './configurationModel.json'
import dashboardPage from './dashboardPage.json'
import errors from './errors.json'
import gamesPage from './gamesPage.json'
import locationsPage from './locationsPage.json'
import platformSettingsPage from './platformSettingsPage.json'
import refine from './refine.json'
import resources from './resources.json'
import roundsPage from './roundsPage.json'
import settingsPage from './settingsPage.json'
import shell from './shell.json'
import simulationPage from './simulationPage.json'
import tenantsPage from './tenantsPage.json'
import usersPage from './usersPage.json'
import validation from './validation.json'

// One catalog per language, merged from its files: Refine's keys (`buttons`,
// `pages`, `table`), the resources' names (`<name>.<name>`), the shell's own
// (`shell`) and one file per extracted area (`auth`: sign-in, password reset,
// invitation; `dashboardPage`; `activityLog`; `usersPage`, `tenantsPage`,
// `cabinetsPage`, `roundsPage`, `locationsPage`, `settingsPage`, `platformSettingsPage`; `gamesPage`,
// `simulationPage`, `configurationModel`, `configurationEditorPage`). Top-level keys must not repeat
// across files (`catalogs.unit.test.ts`).
export const catalog = {
  ...refine,
  ...resources,
  ...shell,
  ...auth,
  ...dashboardPage,
  ...activityLog,
  ...cabinetsPage,
  ...locationsPage,
  ...platformSettingsPage,
  ...roundsPage,
  ...settingsPage,
  ...tenantsPage,
  ...usersPage,
  ...gamesPage,
  ...simulationPage,
  ...configurationModel,
  ...configurationEditorPage,
  ...configIssues,
  ...errors,
  ...validation,
}
